<template>
  <span v-if="dialogFieldOption">
    <!--Dialog para confirmação de exclusão-->
    <p-confirm text="Tem certeza que deseja excluir o item de " :entity="translate('table.custom_fields.title')[1]" :dialog="dialogConfirm" @confirm="deleteItem" @cancel="closeDialogDelete"></p-confirm>
    <!--Create Edit-->
    <!-- <v-divider></v-divider> -->
    <!-- <h4>Opções:</h4> -->
    <v-card style="margin:15px; margin-top:5px;">
      <v-list dense subheader>
        <!-- // Adicionar campo -->
        <v-list-tile>
          <v-text-field id="addCustomOption" v-model="addedItem['id_text']" @keyup.enter="addCustomOption()" @keyup.esc="closeCustomOption" ref="addCustomOption"  placeholder="Digite o nome da Opção" maxlength="190" style="padding-left: 10px;"></v-text-field>
          <v-flex shrink>
            <v-tooltip top>
              <v-btn slot="activator" @click="addCustomOption()" :loading="loadingAddOption" fab small icon class="mx-0">
                <v-icon color="green" medium>done</v-icon>
              </v-btn>
              <span>Adicionar</span>
            </v-tooltip>
          </v-flex>
        </v-list-tile>
        <v-divider></v-divider>
        <div v-if="loadingOptions">
          <v-progress-linear indeterminate :height="3" class="mb-0"></v-progress-linear>
        </div>
        <template v-else v-for="(field, index) in customOptions">
            <!-- // Mostra o campo para editar/criar o registro -->
          <v-list-tile v-if="optionEditing[`cfo_${field['id']}`]" :key="index">
            <v-text-field id="editCustomField" v-model="editedItem['id_text']" @keyup.enter="editCustomOption()" @keyup.esc="closeCustomOption" ref="editCustomField"  placeholder="Digite o nome da Opção" maxlength="190" style="padding-left: 10px;"></v-text-field>
            <v-flex shrink>
              <v-btn @click="editCustomOption()" :loading="loadingAddOption" fab small icon class="mx-0">
                <v-icon medium>done</v-icon>
              </v-btn>
              <v-btn @click="closeCustomOption" fab small icon class="mx-0">
                <v-icon medium>close</v-icon>
              </v-btn>
            </v-flex>
          </v-list-tile>
          <!-- // Mostra o campo de visualizar o registro -->
          <v-list-tile v-else :key="index">
            <v-hover :disabled="$vuetify.breakpoint.smAndDown" :key="index">
              <v-flex grow slot-scope="{ hover }" @click="editItem(field)">
                <v-tooltip top>
                    <span slot="activator" :class="hover ? 'show-edit-border' : 'show-edit'">{{field['id_text']}}</span>
                    <span>Editar</span>
                </v-tooltip>
              </v-flex>
            </v-hover>
            <v-flex shrink>
              <v-tooltip top>
                <v-btn icon class="mx-0" slot="activator" @click="dialogDelete(field)">
                  <v-icon color="pink">delete</v-icon>
                </v-btn>
                <span>Excluir</span>
              </v-tooltip>
            </v-flex>
            <!-- </v-layout> -->
          </v-list-tile>
          <!-- // insere o d pois já é usado o index no list -->
          <v-divider :key="'d' + index" v-if="index + 1 < customOptions.length"></v-divider>
        </template>
        <v-list-tile three-line v-if="customOptions.length === 0">
          Ainda não foram cadastrados itens
        </v-list-tile>
      </v-list>
    </v-card>
  </span>
</template>

<style scoped>
  .show-edit-border {
    display: inline-block;
    padding: 7px;
    cursor: pointer;
    width: 100%;
    border-radius: 5px;
    border: 1px solid;
  }
  .show-edit {
    /* min-height: 50px; */
    padding: 5px;
    border: 1px solid;
    border-color: rgba(255, 255, 255, 0);
    /* padding-left: 5px; */
  }
</style>
<script>
  /* eslint-disable eqeqeq */
  import PConfirm from './PConfirm'

  export default {
    name: 'PCustomFieldOption',
    components: {PConfirm},
    props: {
      field_id: {
        type: Number,
        default: 0
      },
      // view usado para saber se está na inclusão ou edição da tarefa ou tarefa modelo, para fazer os devidos tratamentos
      originView: {
        type: Number,
        default: 0
      }
    },
    data: () => ({
      field: 0,
      // idCount criado para definir o id negativos no momento de inclusão, pois assim não corre o risco de sair algum repetido
      idCount: 0,
      customOptions: [],
      dialogFieldOption: false,
      dialogConfirm: false,
      loadingAddOption: false,
      loadingOptions: false,
      entity: 'custom_field_options',
      // optionEditing identifica e gerencia qual o campo que está em edição
      optionEditing: {},
      defaultFieldEditing: {},
      addedItem: {},
      editedItem: {},
      defaultItem: {}
    }),
    created () {
      this.getOptions()
    },
    methods: {
      getOptions () {
        this.dialogFieldOption = true
        this.addedItem = {id_text: '', custom_field_id: this.field_id}
        this.editedItem = {id_text: '', custom_field_id: this.field_id}
        this.defaultItem = {id_text: '', custom_field_id: this.field_id}
        // se a tarefa ou tarefa modelo for inclusão então não usa o banco, pois isso é feito no fim do processo
        if (this.originView > 2) {
          // Busca as opções do campo
          this.loadingOptions = true
          this.$http.get(`api/${this.entity}?where=custom_field_id=${this.field_id}`).then((res) => {
            this.customOptions = res.body
            this.loadingOptions = false
            setTimeout(() => { document.getElementById('addCustomOption').click() }, 100)
          }, err => {
            console.log(err)
            this.loadingOptions = false
            this.$store.commit('snackbar/change_values', {text: 'Não foi possível incluir o registro de ' + this.translate('table.' + this.entity + '.title')[0] + ', reporte o erro.', color: 'error', dialog: true})
          })
        } else {
          this.customOptions = JSON.parse(JSON.stringify(this.$store.getters[`customField/options`](this.field_id)))
          // this.$store.state[`${this.origin_field_name == 'connection_id' ? 'customFieldConnection' : 'customField'}`].values
          setTimeout(() => { document.getElementById('addCustomOption').click() }, 100)
        }
      },
      editItem (field) {
        // Ao receber o default fechar todos os campos que podem estar abertos
        Object.assign(this.optionEditing, this.defaultFieldEditing)
        this.$set(this.optionEditing, `cfo_${field['id']}`, true)
        // set false no defult para que fechar todos que foram abertos
        this.$set(this.defaultFieldEditing, `cfo_${field['id']}`, false)
        Object.assign(this.editedItem, field)
        // Já foca no campo de edição
        setTimeout(() => {
          document.getElementById('editCustomField').click()
        }, 100)
      },
      addCustomOption () {
        if (this.addedItem['id_text'] === '') {
          this.$store.commit('snackbar/change_values', {
            text: 'Favor preencher o campo!', color: 'warning', dialog: true
          })
          document.getElementById('addCustomOption').click()
          return 0
        }
        // Tira as virgulas caso o usuário tenha adicionado, pois as virgulas que separam os itens na multipla seleção
        this.addedItem['id_text'] = this.addedItem['id_text'].replace(',', '.')
        // se a tarefa ou tarefa modelo for inclusão então não usa o banco, pois isso é feito no fim do processo
        if (this.originView === 2) {
          // idCount Insere um id negativo para não ter risco de ficar ids repetidos
          this.idCount--
          this.addedItem['id'] = this.idCount
          this.customOptions.push(this.addedItem)
          this.$store.commit('customField/add_option', this.addedItem)
          this.addedItem = JSON.parse(JSON.stringify(this.defaultItem))
          document.getElementById('addCustomOption').click()
        } else {
          this.loadingAddOption = true
          this.$http.post('api/' + this.entity, this.addedItem).then(
            (res) => {
              this.customOptions.push(res.body)
              this.loadingAddOption = false
              this.addedItem = JSON.parse(JSON.stringify(this.defaultItem))
              document.getElementById('addCustomOption').click()
              this.$store.commit('snackbar/change_values', {
                text: 'Registro de ' + this.translate('table.' + this.entity + '.title')[0] + ' incluído com sucesso!', color: 'success', dialog: true})
            },
            err => {
              console.log(err)
              this.loadingAddOption = false
              this.$store.commit('snackbar/change_values', { text: 'Não foi possível incluir o registro de ' + this.translate('table.' + this.entity + '.title')[0] + ', reporte o erro.', color: 'error', dialog: true })
            })
        }
      },
      editCustomOption () {
        if (this.editedItem['id_text'] === '') {
          this.$store.commit('snackbar/change_values', {
            text: 'Favor preencher o campo!', color: 'warning', dialog: true
          })
          document.getElementById('editCustomOption').click()
          return 0
        }
        // se a tarefa ou tarefa modelo for inclusão então não usa o banco, pois isso é feito no fim do processo
        if (this.originView === 2) {
          let customFieldAux = this.customOptions.find((val) => { return val.id == this.editedItem['id'] })
          Object.assign(customFieldAux, this.editedItem)
          this.$store.commit('customField/edit_option', this.editedItem)
          this.closeCustomOption()
        } else {
          this.loadingAddOption = true
          this.$http.put('api/' + this.entity + '/' + this.editedItem.id, this.editedItem).then(
            (res) => {
              let customFieldAux = this.customOptions.find((val) => { return val.id == res.body['id'] })
              Object.assign(customFieldAux, res.body)
              this.closeCustomOption()
              this.$store.commit('snackbar/change_values', { text: 'Registro de ' + this.translate('table.' + this.entity + '.title')[0] + ' editado com sucesso!', color: 'success', dialog: true })
            },
            err => {
              console.log(err)
              this.loadingAddOption = false
              this.$store.commit('snackbar/change_values', { text: 'Não foi possível editar o registro de ' + this.translate('table.' + this.entity + '.title')[0] + ', reporte o erro.', color: 'error', dialog: true })
            })
        }
      },
      closeCustomOption () {
        this.loadingAddOption = false
        // Ao receber o default fechar o campo que estão aberto
        Object.assign(this.optionEditing, this.defaultFieldEditing)
        this.addedItem = JSON.parse(JSON.stringify(this.defaultItem))
        this.editedItem = JSON.parse(JSON.stringify(this.defaultItem))
        // joga os valores defalt dentro do editedItem
        Object.assign(this.editedItem, this.defaultItem)
      },
      dialogDelete (field) {
        this.dialogConfirm = true
        // Joga o defaultFieldEditing para fechar alguma edição que esteja aberta
        Object.assign(this.optionEditing, this.defaultFieldEditing)

        this.editedItem = JSON.parse(JSON.stringify(this.defaultItem))
        Object.assign(this.editedItem, field)
      },
      closeDialogDelete () {
        this.dialogConfirm = false
        this.editedItem = JSON.parse(JSON.stringify(this.defaultItem))
      },
      deleteItem () {
        // se a tarefa ou tarefa modelo for inclusão então não usa o banco, pois isso é feito no fim do processo
        if (this.originView === 2) {
          let customFieldId = this.editedItem['id']
          this.customOptions = this.customOptions.filter((val) => { return val.id != customFieldId })
          this.$store.commit('customField/delete_option', this.editedItem)
          this.closeDialogDelete()
        } else {
          this.$store.commit('loader/change_dialog', true)
          this.$http.delete(`api/${this.entity}/${this.editedItem.id}`).then(
            (res) => {
              let customFieldId = res.body['id']
              this.customOptions = this.customOptions.filter((val) => { return val.id != customFieldId })
              this.closeDialogDelete()
              this.$store.commit('loader/change_dialog', false)
              this.$store.commit('snackbar/change_values', { text: 'Registro de campo personalizado excluído com sucesso!', color: 'success', dialog: true })
            },
            err => {
              console.log(err)
              this.$store.commit('loader/change_dialog', false)
              this.$store.commit('snackbar/change_values', { text: 'Não foi possível deletar o registro campo personalizado, o erro.', color: 'error', dialog: true })
            })
        }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/shared/PCustomFieldOption.vue